import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Checkbox, Form, Input, Modal, Select, message } from "antd";
import { Row, Col } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import API from "../../../config/api";
import { POST, PUT } from "../../../utils/apiCalls";
import "../styles.scss"
function MailForm(props: any) {
  const [form] = Form.useForm();
  const Events = useSelector((state: any) => state.Events);
  const [value, setValue] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const selectedType = Form.useWatch("type", form);
  const [sendMailAttendees, setSendMailAttendees] = useState<boolean>(false);


  useEffect(() => {
    setValue(props?.data?.content);
    setSendMailAttendees(props?.data?.sendto_attendees || false);

    form.setFieldsValue({
      name: props?.data?.name,
      subject: props?.data?.subject,
      content: props?.data?.content,
      type: props?.data?.type,
      sendto_attendees: props?.data?.sendto_attendees || false,
    });
  }, [form, props?.data]);


  const renderVariablesInline = () => {
    let items: any[] = [];

    if (selectedType === "notification") {
      items = [
        <span className="pillStyle">Investor Name: ${"{InvestorName}"}</span>,
        <span className="pillStyle">EventDate: ${"{EventDate}"}</span>,
        <span className="pillStyle">Location: ${"{Location}"}</span>,
        <span className="pillStyle">Meeting Room: ${"{Room}"}</span>,
        <span className="pillStyle">Meetings: ${"{Meeting_slots}"}</span>,
        <span className="pillStyle">Investor Details Page: ${"{Link}"}</span>,
      ];
    }

    if (selectedType === "acknowledge") {
      items = [
        <span className="pillStyle">Investor Name: ${"{InvestorName}"}</span>,
        <span className="pillStyle">EventDate: ${"{EventDate}"}</span>,
        <span className="pillStyle">Location: ${"{Location}"}</span>,
        <span className="pillStyle">Investor Details Page: ${"{Link}"}</span>,
      ];
    }

    if (!items.length) return null;

    // Split into two equal chunks
    const firstCol = items.slice(0, Math.ceil(items.length / 2));
    const secondCol = items.slice(Math.ceil(items.length / 2));

    return (
      <Row>
        <Col md={6}>
          <div className="wrapStyle">{firstCol}</div>
        </Col>

        <Col md={6}>
          <div className="wrapStyle">{secondCol}</div>
        </Col>
      </Row>
    );
  };

  const processHtml = (html: string) => {
    let updated = html;

    // 1️⃣ Normalize all <p> tags to tight spacing (email safe)
    updated = updated
      .replace(/<p>/g, '<p style="margin: 0 0 6px 0; padding: 0; line-height: 1.3;">')
      .replace(
        /<p style="[^"]*">/g,
        '<p style="margin: 0 0 6px 0; padding: 0; line-height: 1.3;">'
      );

    // 2️⃣ Replace Quill's empty <p><br></p> with a tiny safe spacer
    updated = updated.replace(
      /<p><br><\/p>/g,
      '<p style="margin: 3px 0;"></p>'
    );

    // 3️⃣ Replace <br/> with small controlled gap (<span> is Quill-safe)
    updated = updated.replace(
      /<br\s*\/?>/g,
      '<span style="display: block; height: 4px;"></span>'
    );

    // 4️⃣ Remove extra multiple blank spacers (cleanup)
    updated = updated.replace(
      /(<span style="display: block; height: 4px;"><\/span>\s*){2,}/g,
      '<span style="display: block; height: 4px;"></span>'
    );

    return updated;
  };

  const submit = async (data: any) => {
    try {
      setLoading(true);
      let obj = {
        id: props?.data?.id,
        name: data?.name,
        subject: data?.subject,
        content: processHtml(value),
        type: data?.type,
        eventId: Events?.defult?.id,
        sendto_attendees: sendMailAttendees
      };
      let url = props?.data?.id
        ? API.MAIL_TEMPLATE_EDIT + props?.data?.id
        : API.MAIL_TEMPLATE_ADD;

      let response: any = props?.data?.id
        ? await PUT(url, obj)
        : await POST(url, obj);

      if (response.status) {
        props?.onChange();
        props.onClose();
        message.success("Successfully submitted");
      } else {
        message.error("Oops.something gone wrong.");
      }
      setLoading(false);
    } catch (err) {
      console.log("err", err);
      message.error("Oops.something gone wrong.");
      setLoading(false);
    }
  };

  return (
    <Modal
      title={"Mail Template"}
      open={props.visible}
      onCancel={() => props.onClose()}
      footer={false}
      centered
      width={700}
      maskClosable={false}
    >
      <Form form={form} onFinish={submit}>
        <Row>
          <Col md={12}>
            <div className="label">Template Name</div>
            <Form.Item
              name="name"
              rules={[{ required: true, message: "Missing Email" }]}
            >
              <Input value={props?.data?.email} size="large" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <div className="label">Template Type</div>
            <Form.Item
              name="type"
              rules={[{ required: true, message: "Missing Type" }]}
            >
              <Select
                options={[
                  { value: "custom", label: <span>Custom Email Template</span> },
                  {
                    value: "acknowledge",
                    label: <span>Acknowledge Email Template</span>,
                  },
                  {
                    value: "notification",
                    label: <span>Notification Email Template</span>,
                  },
                ]}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={12}>
            <div className="label">Subject</div>
            <Form.Item
              name={"subject"}
              rules={[{ required: true, message: "Subject Required" }]}
            >
              <Input size="large" />
            </Form.Item>

          </Col>
        </Row>
        <div className="label">Content</div>
        <Form.Item name={"content"}>
          <div style={{ display: "none" }}>{value}</div>
          <ReactQuill
            style={{ height: 300 }}
            theme="snow"
            value={value}
            onChange={setValue}
          />
        </Form.Item>
        <br /> <br />
        <Row>
          <Col sm={6}>
            {selectedType != "custom" &&
              <Form.Item name="sendto_attendees" valuePropName="checked">
                <Checkbox
                  disabled={loading}
                  checked={sendMailAttendees}
                  onChange={(e) => setSendMailAttendees(e.target.checked)}
                >
                  Send To Attendees
                </Checkbox>
              </Form.Item>
            }
          </Col>
          <Col sm={3}>
            <Button size="large" block danger onClick={() => props.onClose()}>
              Close
            </Button>
          </Col>
          <Col sm={3}>
            <Button
              size="large"
              type="primary"
              block
              htmlType="submit"
              loading={loading}
            >
              Save
            </Button>
          </Col>
          <Col md={12}>{renderVariablesInline()}</Col>
        </Row>

      </Form>
    </Modal>
  );
}

export default MailForm;
